export default {"src":"/_next/static/media/heating.a2c04113.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};